<template>
	<div class="tab-position">
		<div class="tab-position course-session-background">
			<session-create-view :edit_view="!createView" :create_view="createView" :table_view="false" :no_border="createView" @addProgramButtonDisable="addProgramButtonDisable"/>
			<div v-if="createView" class="flex">
				<button :disabled="ok_button_disable" :class="{'input-disabled': ok_button_disable}"  class="button margin-left" @click="CreateSession"><img class="mr-1" src="../../../assets/images/icons/solid/plus-circle-white.svg" width="13"/>Create Session</button>
			</div>
			

		</div>

	</div>
</template>
<script>
 import SessionCreateView from '../../shared/sessionCreateView'
 import { EventBus } from './../../../event_bus.js';
export default {
	components : {
		 SessionCreateView
	},
	computed : {
		createView(){
			return this.$route.fullPath.includes('session-create')
		}
	},
	data: function(){
		return{
			ok_button_disable: true,

		}
	},
	created : function(){

	},
	methods : {
		addProgramButtonDisable(val){
			this.ok_button_disable = val
		},
		CreateSession(){
			EventBus.$emit('checkSessionStatus')
		}

	}
	
}
</script>
<style scoped src="./organizationcourse.css">
</style>



// WEBPACK FOOTER //
// src/components/organizations/courses/OrganizationCourseSessionCreate.vue